"use client";
import { Box, Button, Stack, styled, Typography } from "@mui/material";
import Image from "next/image";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { TitleGradientText } from "../title_gradient_text";
import { useRouter } from "next/navigation";
import { allNewsEventsData } from "@/data/news_mock_data";

const BlackDropBlur = styled(Box)`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: calc(100% + 1px);
  z-index: -1;
  background-color: rgba(11, 17, 20, 0.01);
  backdrop-filter: blur(100px);
`;

export function NewsSection() {
  const router = useRouter();

  const handleRecommendedMenusClick = () => {
    router.push("/news-events");
  };

  return (
    <Stack
      width="100%"
      justifyContent="center"
      alignItems="center"
      px={{
        xs: 4,
        md: 30,
      }}
      py={{
        xs: 15,
        md: 25,
      }}
      gap={{
        xs: 12,
        md: 15,
      }}
      position="relative"
    >
      <Stack gap={2}>
        <TitleGradientText variant="h3" textAlign="center">
          ข่าวสารและกิจกรรม
        </TitleGradientText>
        <TitleGradientText variant="body1" textAlign="center">
          ดูข่าวสารอื่น ๆ ของเราเพิ่มเติม
        </TitleGradientText>
      </Stack>

      <Box
        position="absolute"
        zIndex={-2}
        left={`calc(50% - 200px)`}
        top={`calc(50% - 200px)`}
      >
        <Image
          src="/images/home/slide_bg_center.png"
          width="400"
          height="400"
          alt=""
        />
      </Box>
      <BlackDropBlur />

      <Stack
        direction={{
          xs: "column",
          md: "row",
        }}
        gap={5}
        width="100%"
      >
        {allNewsEventsData.slice(0, 3).map((news) => (
          <Stack
            key={news.id}
            flex={1}
            width="100%"
            gap={6}
            onClick={() =>
              router.push(`/news-events/${encodeURIComponent(news.title)}`)
            }
            sx={{
              cursor: "pointer",
            }}
          >
            <Stack
              width="100%"
              height="280px"
              position="relative"
              borderRadius={4}
              overflow="hidden"
            >
              <Image
                src={news.imageUrl}
                alt={news.title}
                fill
                style={{
                  objectFit: "cover",
                }}
              />
            </Stack>
            <Stack gap={1.5} alignItems="center">
              <Typography
                sx={{
                  fontSize: { xs: 18, md: 18 },
                  fontWeight: 700,
                  lineHeight: { xs: "26px", md: "26px" },
                  color: "#ffffff",
                  fontFamily: "var(--font-noto)",
                  textAlign: "center",
                }}
              >
                {news.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: 16, md: 16 },
                  fontWeight: 400,
                  lineHeight: { xs: "24px", md: "24px" },
                  color: "#9e9e9f",
                  fontFamily: "var(--font-noto)",
                  textAlign: "center",
                }}
              >
                {news.description}
              </Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>

      <Stack>
        <Button variant="contained" onClick={handleRecommendedMenusClick}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="button" color="textPrimary">
              ข่าวสารและกิจกรรม
            </Typography>
            <ArrowForwardRoundedIcon
              style={{
                color: "#fff",
              }}
            />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
}
